/* eslint-disable react-hooks/exhaustive-deps */
import Grid from "@mui/material/Grid";
import axios from "axios";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FormLabel from "@mui/material/FormLabel";
import { Button, Flex, TimePicker } from "antd";
import OutlinedInput from "@mui/material/OutlinedInput";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useSnackbar } from "notistack";
import { Switch } from "antd";
import { State, City } from "country-state-city";
import { Checkbox, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import services from "./components/Services";
import { Image, Upload } from "antd";
import { TextField, InputAdornment } from "@mui/material";
import dayjs from "dayjs";
import { useMaterialUIController } from "context";
import LocationPicker from "./components/LocationPicker";

import { handleSignout } from "utils/Logout";
import { isValidPhone } from "utils/Constant";
import { isValidEmail } from "utils/Constant";
import { allowOnlyAlphanumericAndSpace } from "utils/Constant";
import { allowDubaiAddress } from "utils/Constant";

const { RangePicker } = TimePicker;

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

function UpdateLocation() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const [states] = useState(State.getStatesOfCountry("AE"));
  const [cities, setCities] = useState([]);


  const [locationAvailableSlots, setLocationAvailableSlots] = useState([]);
  const [imageupdt, setImageupdt] = useState(false);
  const [range, setRange] = useState([null, null]);
  const row_data = location.state || {};
  const [defaultFac] = useState(
    row_data?.facilities?.map((facility) => facility.name || "") || []
  );


  const [errors, setErrors] = useState({});

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
        color: "grey",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );
  const handleUploadChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    setImageupdt(true);
  };
  useEffect(() => {
    getState();
    getImage();

  }, []);

  const [selectAfterValue, setSelectAfterValue] = useState("AED");

  const [parkingCost, setParkingCost] = useState({
    amount: "",
    currency: "AED",
  });

  const mapApiSlotsToRanges = (slots = []) => {
    try {
      const parsed = typeof slots === "string" ? JSON.parse(slots) : slots;

      return parsed.map((slot) => ({
        start: dayjs(slot.startTime, "HH:mm"),
        end: dayjs(slot.endTime, "HH:mm"),
        enabled: slot.enabled,
        timezone: slot.timezone,
        _id: slot._id,
      }));
    } catch (e) {
      console.error("Invalid activeOperationalHoursSlots", e);
      return [{ start: null, end: null }];
    }
  };


  const [timeRanges, setTimeRanges] = useState(() =>
    row_data?.activeOperationalHoursSlots
      ? mapApiSlotsToRanges(row_data.activeOperationalHoursSlots)
      : [{ start: null, end: null }]
  );


  const isOverlapping = (ranges, currentIndex, newStart, newEnd) => {
    return ranges.some((range, index) => {
      if (
        index === currentIndex ||
        !range.start ||
        !range.end
      )
        return false;

      return (
        newStart.isBefore(range.end) &&
        newEnd.isAfter(range.start)
      );
    });
  };

  useEffect(() => {
    if (row_data?.activeOperationalHoursSlots) {
      setTimeRanges(
        mapApiSlotsToRanges(row_data.activeOperationalHoursSlots)
      );
    }
  }, [row_data]);


  const handleCurrencyChange = (event) => {
    const newCurrency = event.target.value;
    setSelectAfterValue(newCurrency);
    setParkingCost((prev) => ({
      ...prev,
      currency: newCurrency,
    }));
  };

  const handleAmountChange = (event) => {
    const newAmount = event.target.value;
    setParkingCost((prev) => ({
      ...prev,
      amount: newAmount,
    }));
  };

  const getInitialValues = () => ({
    locationName: row_data.locationName || "",
    locationType: row_data.locationType || "",
    state: row_data.state || "",
    city: row_data.city || "",
    address: row_data.address || "",
    facilities: row_data.facilities || [],
    workingDays: row_data.workingDays || "",
    workingHours: row_data.workingHours || "",
    freepaid: row_data.freepaid || {
      parking: true,
      charging: true,
    },
    direction: row_data?.direction,
    salesManager: row_data.salesManager || {
      name: "",
      phoneNumber: "",
      email: "",
    },
    dealer: row_data.dealer || { name: "", phoneNumber: "", email: "" },
    locationImage: row_data.locationImage || [],
  });
  const [values, setValues] = useState(getInitialValues);

  console.log("Row data", row_data);

  const initialLocation =
    { lat: values?.direction?.latitude, lng: values?.direction?.longitude } ||
    {};
  const onChange = (checkedValues) => {
    setValues((prevValues) => ({
      ...prevValues,
      facilities: checkedValues,
    }));
  };
  const handleFreePaidChange = (event) => {
    setValues((prevValues) => {
      return {
        ...prevValues,
        freepaid: {
          ...prevValues["freepaid"],
          parking: event,
        },
      };
    });
  };
  const handleFreePaidChangeCharging = (event) => {
    setValues((prevValues) => {
      return {
        ...prevValues,
        freepaid: {
          ...prevValues["freepaid"],
          charging: event,
        },
      };
    });
  };
  const handleRangeChange = (index, values) => {
    if (!values) return;

    const [start, end] = values;

    if (!start || !end) return;

    if (isOverlapping(timeRanges, index, start, end)) {
      enqueueSnackbar('Time ranges cannot overlap', { variant: 'error', autoHideDuration: 2000 });
      return;
    }

    const updated = [...timeRanges];
    updated[index] = { start, end };
    setTimeRanges(updated);
  };

  const addTimeSlot = () => {
    setTimeRanges([...timeRanges, { start: null, end: null }]);
  };

  const removeTimeSlot = (index) => {
    setTimeRanges(timeRanges.filter((_, i) => i !== index));
  };


  const buildPayload = () => {
    return timeRanges
      .filter((r) => r.start && r.end)
      .map((r) => ({
        enabled: true,
        startTime: r.start.format("HH:mm"),
        endTime: r.end.format("HH:mm"),
        timezone: "Asia/Dubai",
      }));

  };


  const handleDealerChange = (event) => {
    const { name, value } = event.target;

    setValues((prevValues) => ({
      ...prevValues,
      dealer: {
        ...prevValues.dealer,
        [name.split(".")[1]]: value,
      },
    }));
  };
  const handleSalesManagerChange = (event) => {
    const { name, value } = event.target;

    setValues((prevValues) => ({
      ...prevValues,
      salesManager: {
        ...prevValues.salesManager,
        [name.split(".")[1]]: value,
      },
    }));
  };

  const getImage = () => {
    if (values.locationImage.length > 0) {
      const formattedImages = values.locationImage.map((url, index) => ({
        uid: `${index}`, // Unique identifier for each image
        name: `Image_${index + 1}`, // Name to display
        status: "done", // Mark as already uploaded
        url: `/${url}`, // Image URL
      }));
      setFileList(formattedImages);
    }
  };
  useEffect(() => {
    setValues(getInitialValues);
    if (row_data?.parkingCost) {
      setParkingCost({ ...row_data.parkingCost }); // Ensure a new reference
      setSelectAfterValue(row_data.parkingCost.currency);
    }
  }, [row_data]);



  const getState = () => {
    try {
      const selectedState = row_data?.state;
      setValues((prevValues) => ({
        ...prevValues,
        state: selectedState,
        city: "",
      }));
      const stateIsoCode = states.find(
        (state) => state.name === selectedState
      )?.isoCode;
      setCities(City.getCitiesOfState("AE", stateIsoCode));
    } catch (error) { }
  };
  const handleStateChange = (event) => {
    const selectedState = event.target.value;
    setValues((prevValues) => ({
      ...prevValues,
      state: selectedState,
      city: "",
    }));
    const stateIsoCode = states.find(
      (state) => state.name === selectedState
    )?.isoCode;
    setCities(City.getCitiesOfState("AE", stateIsoCode));
  };
  const createUser = (
    locationName,
    locationType,
    state,
    city,
    address,
    facilities,
    workingDays,
    workingHours,
    freepaid,
    salesManager,
    dealer,
    direction
  ) => {
    const selectedFacilities = services
      .filter((service) => facilities.includes(service.name))
      .map((service) => ({
        name: service.name,
        icon: service.icon,
      }));
    const payload = {
      locationName: locationName,
      locationType: locationType,
      state: state,
      city: city,
      address: address,
      facilities:
        selectedFacilities.length === 0 ? facilities : selectedFacilities,
      workingDays: workingDays,
      activeOperationalHoursSlots: JSON.stringify(locationAvailableSlots),
      freepaid: freepaid,
      salesManager: salesManager,
      dealer: dealer,
      parkingCost: parkingCost,
      direction: direction,
    };
    axios({
      method: "put",
      url: process.env.REACT_APP_BASEURL + "charger-locations/" + row_data?._id,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,

    })
      .then((response) => {
        if (response.data.success === true) {
          if (imageupdt) {
            updateImage();
          } else {
            enqueueSnackbar("Location Updated Successfully!!", {
              variant: "success",
            });
            navigate("/location");
          }
        } else {
          enqueueSnackbar("An error occurred while updating the location.", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error, { variant: "error" });
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
  };

  const RANGE_WIDTH = 280;
  const updateImage = () => {
    const bodyFormData = new FormData();
    (fileList || []).forEach((file, index) => {
      if (file?.originFileObj) {
        bodyFormData.append("locationImage", file?.originFileObj);
      }
    });
    (fileList || []).forEach((file, index) => {
      var i = 0;
      if (file?.url) {
        bodyFormData.append(`locationImageUrl[${i}]`, file?.url);
        i++;
      }
    });
    bodyFormData.append("locationId", row_data?._id);
    axios({
      method: "put",
      url: process.env.REACT_APP_BASEURL + "charger-locations/update-image",
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,

    })
      .then((response) => {
        if (response.data.success === true) {
          enqueueSnackbar("Location Updated Successfully!!", {
            variant: "success",
          });
          navigate("/location");
          window.location.reload();
        } else {
          enqueueSnackbar(
            "An error occurred while updating the location Image.",
            { variant: "error" }
          );
        }
      })
      .catch((error) => {
        enqueueSnackbar(error, { variant: "error" });
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
  };

  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  const handlePropChange = (updatedValues) => {
    setValues((prev) => ({
      ...prev,
      ...updatedValues,
    }));
  };
  const handleLocationChange = (location) => {
    setValues((prevValues) => ({
      ...prevValues,
      direction: location,
    }));
  };

  const handleWorkingHourSave = () => {
    const workingHr = buildPayload();
    setLocationAvailableSlots(workingHr);
    enqueueSnackbar("Working hours updated successfully", { variant: "success", autoHideDuration: 2000 });

  }



  const handleSubmit = (event) => {
    event.preventDefault();

    // Required Fields
    if (
      !values.locationName ||
      !values.locationType ||
      !values.state ||
      !values.city ||
      !values.address ||
      !values.workingDays
    ) {
      return enqueueSnackbar("Please Fill All The Details !!!", { variant: "error" });
    }

    // Direction validation (same as Add flow)
    if (!values.direction?.latitude || !values.direction?.longitude) {
      return enqueueSnackbar("Please Enter the location correctly !!!", { variant: "error" });
    }

    // Image validation
    if (fileList.length === 0) {
      return enqueueSnackbar("Please upload at least one location image!", {
        variant: "error",
      });
    }

    // Parking validation
    if (!values.freepaid.parking && parkingCost.amount === "") {
      return enqueueSnackbar(
        "Parking Amount is necessary when selected paid parking.",
        { variant: "error" }
      );
    }

    // ✅ Location Name validation (MATCH ADD FLOW)
    if (!allowDubaiAddress(values.locationName)) {
      return enqueueSnackbar(
        "Invalid Location Name: Only letters, numbers, spaces and , / - . # ( ) ' are allowed",
        { variant: "error" }
      );
    }

    // ✅ Address validation (MATCH ADD FLOW)
    if (!allowDubaiAddress(values.address)) {
      return enqueueSnackbar(
        "Invalid Address : Only letters, numbers, spaces and , / - . # ( ) ' are allowed",
        { variant: "error" }
      );
    }

    // ✅ Working hours validation
    const workingHr = buildPayload();
    if (workingHr.length === 0) {
      return enqueueSnackbar("At least one working hour is required!", {
        variant: "error",
      });
    }

    // Save working hours before submit
    setLocationAvailableSlots(workingHr);

    // Sales Manager validation
    if (!allowOnlyAlphanumericAndSpace(values.salesManager.name)) {
      return enqueueSnackbar("Invalid Site Engineer Name", { variant: "error" });
    }

    if (!isValidEmail(values.salesManager.email)) {
      return enqueueSnackbar("Invalid Email", { variant: "error" });
    }

    if (!isValidPhone(values.salesManager.phoneNumber)) {
      return enqueueSnackbar("Invalid phone number", { variant: "error" });
    }

    // Dealer validation
    if (!allowOnlyAlphanumericAndSpace(values.dealer.name)) {
      return enqueueSnackbar("Invalid Security Guard Name", { variant: "error" });
    }

    if (!isValidEmail(values.dealer.email)) {
      return enqueueSnackbar("Invalid Email", { variant: "error" });
    }

    if (!isValidPhone(values.dealer.phoneNumber)) {
      return enqueueSnackbar("Invalid phone number", { variant: "error" });
    }

    createUser(
      values.locationName,
      values.locationType,
      values.state,
      values.city,
      values.address,
      values.facilities,
      values.workingDays,
      values.workingHours,
      values.freepaid,
      values.salesManager,
      values.dealer,
      values?.direction
    );
  };

  const handlePreviewClose = () => {
    setPreviewImage("");
    setPreviewOpen(false);
  };

  const reset = (event) => {
    event.preventDefault();
    getState();
    getImage();

    setValues(getInitialValues());
    setParkingCost({
      amount: "",
      currency: "AED",
    });
    setSelectAfterValue("AED");
  };
  return (
    <DashboardLayout>
      {previewImage && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => {
              setPreviewOpen(visible);
              if (!visible) handlePreviewClose();
            },
            afterOpenChange: (visible) => {
              if (!visible) handlePreviewClose();
            },
          }}
          src={previewImage}
        />
      )}
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <MDTypography variant="h6" color="white">
                  Update Location Information
                </MDTypography>
              </MDBox>

              <MDBox p={4} component="form" role="form">
                <MDBox p={1}>
                  {initialLocation && (
                    <LocationPicker
                      initialLocation={initialLocation}
                      onLocationChange={handleLocationChange}
                      onValueChange={handlePropChange}
                      values={values}
                    />
                  )}
                </MDBox>
                <MDBox p={1}>
                  <MDInput
                    type="text"
                    label="Location Name"
                    value={values.locationName}
                    name="locationName"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                    onBlur={(e) => {
                      const value = e.target.value;

                      setErrors((prev) => ({
                        ...prev,
                        locationName: allowDubaiAddress(value)
                          ? ""
                          : "Invalid Location Name: Only letters, numbers, spaces and , / - . # ( ) ' are allowed",
                      }));
                    }}
                    error={Boolean(errors.locationName)}
                    helperText={errors.locationName}
                    FormHelperTextProps={{
                      sx: {
                        color: "#d32f2f",
                        fontSize: "12px",
                        marginLeft: "4px",
                      },
                    }}
                  />
                </MDBox>

                <MDBox p={1}>
                  <FormControl fullWidth>
                    <InputLabel id="location-type-label">
                      Location Type
                    </InputLabel>
                    <Select
                      sx={{
                        height: 50,
                      }}
                      labelId="location-type-label"
                      id="location-type-select"
                      value={values.locationType}
                      name="locationType"
                      onChange={handleChange}
                      input={<OutlinedInput label="Location Type" />}
                    >
                      <MenuItem value="Petrol Pumps">Petrol Pumps</MenuItem>
                      <MenuItem value="Malls">Malls</MenuItem>
                      <MenuItem value="Highways">Highways</MenuItem>
                      <MenuItem value="Resorts">Resorts</MenuItem>
                      <MenuItem value="Airports">Airports</MenuItem>
                      <MenuItem value="Hotels">Hotels</MenuItem>
                      <MenuItem value="Parking Garages">
                        Parking Garages
                      </MenuItem>
                      <MenuItem value="Office Complexes">
                        Office Complexes
                      </MenuItem>
                      <MenuItem value="Supermarkets">Supermarkets</MenuItem>
                      <MenuItem value="Train Stations">Train Stations</MenuItem>
                      <MenuItem value="Restaurants">Restaurants</MenuItem>
                      <MenuItem value="Residential Areas">
                        Residential Areas
                      </MenuItem>
                      <MenuItem value="Parks and Recreational Areas">
                        Parks and Recreational Areas
                      </MenuItem>
                      <MenuItem value="University Campuses">
                        University Campuses
                      </MenuItem>
                      <MenuItem value="Convention Centers">
                        Convention Centers
                      </MenuItem>
                      <MenuItem value="Stadiums and Sports Arenas">
                        Stadiums and Sports Arenas
                      </MenuItem>
                      <MenuItem value="Movie Theaters">Movie Theaters</MenuItem>
                      <MenuItem value="Hospitals">Hospitals</MenuItem>
                      <MenuItem value="Government Buildings">
                        Government Buildings
                      </MenuItem>
                      <MenuItem value="Libraries">Libraries</MenuItem>
                      <MenuItem value="Community Centers">
                        Community Centers
                      </MenuItem>
                      <MenuItem value="Beach Parking Lots">
                        Beach Parking Lots
                      </MenuItem>
                      <MenuItem value="Tourist Attractions">
                        Tourist Attractions
                      </MenuItem>
                      <MenuItem value="Car Dealerships">
                        Car Dealerships
                      </MenuItem>
                      <MenuItem value="Metro Stations">Metro Stations</MenuItem>
                    </Select>
                  </FormControl>
                </MDBox>
                <MDBox p={1}>
                  <MDInput
                    type="text"
                    label="Address"
                    value={values.address}
                    name="address"
                    multiline
                    rows={4}
                    margin="dense"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const value = e.target.value;

                      setErrors((prev) => ({
                        ...prev,
                        address: allowDubaiAddress(value)
                          ? ""
                          : "Invalid Location Name: Only letters, numbers, spaces and , / - . # ( ) ' are allowed",
                      }));
                    }}
                    error={Boolean(errors.address)}
                    helperText={errors.address}
                    FormHelperTextProps={{
                      sx: {
                        color: "#d32f2f",
                        fontSize: "12px",
                        marginLeft: "4px",
                      },
                    }}
                  />
                </MDBox>
                <MDBox p={1}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-multiple-name-label">State</InputLabel>
                    <Select
                      sx={{
                        height: 50,
                      }}
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      placeholder="Select State"
                      value={values.state}
                      name="state"
                      onChange={handleStateChange}
                      input={<OutlinedInput label="State" />}
                    >
                      {states.map((state, index) => (
                        <MenuItem key={index} value={state.name}>
                          {state.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </MDBox>
                <MDBox p={1}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-multiple-name-label">City</InputLabel>
                    <Select
                      sx={{
                        height: 50,
                      }}
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      placeholder="Select City"
                      value={values.city}
                      name="city"
                      onChange={handleChange}
                      input={<OutlinedInput label="City" />}
                    >
                      {cities.map((city, index) => (
                        <MenuItem key={index} value={city.name}>
                          {city.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </MDBox>
                <MDBox p={1}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-multiple-name-label">
                      Working Days
                    </InputLabel>
                    <Select
                      sx={{
                        height: 50,
                      }}
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      placeholder="Select Working Days"
                      value={values.workingDays}
                      name="workingDays"
                      onChange={handleChange}
                      input={<OutlinedInput label="Working Days" />}
                    >
                      <MenuItem value={"Everyday"}>Everyday</MenuItem>
                      <MenuItem value={"Monday-Saturday"}>
                        Monday-Saturday
                      </MenuItem>
                      <MenuItem value={"Monday-Friday"}>Monday-Friday</MenuItem>
                      <MenuItem value={"Monday-Thrusday"}>
                        Monday-Thrusday
                      </MenuItem>
                    </Select>
                  </FormControl>
                </MDBox>
                <MDBox p={1}>
                  <FormLabel>Working Hours</FormLabel>

                  <Flex gap={15} style={{ flexDirection: "column", marginTop: 10 }}>
                    {timeRanges.map((range, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          gap: 10,
                          alignItems: "center",
                        }}
                      >
                        <RangePicker
                          use12Hours
                          format="h a"
                          style={{ width: RANGE_WIDTH }}
                          value={
                            range.start && range.end
                              ? [range.start, range.end]
                              : null
                          }
                          onChange={(values) =>
                            handleRangeChange(index, values)
                          }
                          needConfirm={false}
                        />

                        {timeRanges.length > 1 && (
                          <Button danger onClick={() => removeTimeSlot(index)}>
                            Remove
                          </Button>
                        )}
                      </div>
                    ))}

                    {/* Add Time Slot */}
                    <Button
                      type="dashed"
                      style={{ width: RANGE_WIDTH }}
                      onClick={addTimeSlot}
                    >
                      + Add Time Slot
                    </Button>

                    {/* Save Working Hours */}
                    <Button
                      type="primary"
                      style={{ width: RANGE_WIDTH }}
                      onClick={handleWorkingHourSave}
                    >
                      Save Working Hours
                    </Button>
                  </Flex>
                </MDBox>

                <MDBox p={1}>
                  <FormLabel>Facilities</FormLabel>

                  <Checkbox.Group
                    style={{
                      width: "100%",
                    }}
                    onChange={onChange}
                    defaultValue={defaultFac}
                  >
                    <Row gutter={16}>
                      {services.map((service, index) => (
                        <Col key={index} xs={24} sm={12} md={8}>
                          <Checkbox value={service.name}>
                            {service.name}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </MDBox>
                <Grid container>
                  <Grid item xs={6}>
                    <MDBox p={1}>
                      <FormLabel>Free Parking</FormLabel>
                      <br />
                      <Switch
                        checked={values.freepaid.parking}
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        onChange={handleFreePaidChange}
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={6}>
                    <MDBox p={1}>
                      <FormLabel>Free Charging</FormLabel>
                      <br />
                      <Switch
                        checked={values.freepaid.charging}
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        onChange={handleFreePaidChangeCharging}
                      />
                    </MDBox>
                  </Grid>
                </Grid>
                {!values.freepaid.parking && (
                  <MDBox p={1}>
                    <FormControl fullWidth>
                      <TextField
                        label="Parking Cost Per Hours"
                        name="parkingCost"
                        required
                        variant="outlined"
                        type="number"
                        value={parkingCost.amount}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FormControl variant="standard" size="small">
                                <Select
                                  value={selectAfterValue}
                                  onChange={handleCurrencyChange}
                                >
                                  <MenuItem value="AED">د.إ</MenuItem>
                                  <MenuItem value="INR">₹</MenuItem>
                                  <MenuItem value="USD">$</MenuItem>
                                  <MenuItem value="EUR">€</MenuItem>
                                  <MenuItem value="GBP">£</MenuItem>
                                  <MenuItem value="CNY">¥</MenuItem>
                                </Select>
                              </FormControl>
                            </InputAdornment>
                          ),
                        }}
                        onChange={handleAmountChange}
                      />
                    </FormControl>
                  </MDBox>
                )}

                <MDBox p={1}>
                  <MDInput
                    type="text"
                    label="Site Engineer Name"
                    value={values.salesManager.name}
                    name="salesManager.name"
                    margin="dense"
                    fullWidth={true}
                    onChange={handleSalesManagerChange}
                    onBlur={(e) => {
                      const value = e.target.value;
                      setErrors((prev) => ({
                        ...prev,
                        salesManagerName: allowOnlyAlphanumericAndSpace(value)
                          ? ""
                          : "Only letters are allowed.",
                      }));
                    }}
                    error={Boolean(errors.salesManagerName)}
                    helperText={errors.salesManagerName}
                    FormHelperTextProps={{
                      sx: {
                        color: "#d32f2f",
                        fontSize: "12px",
                        marginLeft: "4px",
                      },
                    }}
                  />
                </MDBox>

                <MDBox p={1}>
                  <MDInput
                    type="email"
                    label="Site Engineer Email"
                    value={values.salesManager.email}
                    name="salesManager.email"
                    margin="dense"
                    pattern=".+@+.+.com"
                    fullWidth={true}
                    onChange={handleSalesManagerChange}
                    onBlur={(e) => {
                      const value = e.target.value;

                      setErrors((prev) => ({
                        ...prev,
                        salesManagerEmail: isValidEmail(value)
                          ? ""
                          : "Enter valid email address.",
                      }));
                    }}
                    error={Boolean(errors.salesManagerEmail)}
                    helperText={errors.salesManagerEmail}
                    FormHelperTextProps={{
                      sx: {
                        color: "#d32f2f",
                        fontSize: "12px",
                        marginLeft: "4px",
                      },
                    }}
                  />
                </MDBox>
                <MDBox p={1}>
                  <MDInput
                    type="number"
                    label="Site Engineer Phone"
                    value={values.salesManager.phoneNumber}
                    name="salesManager.phoneNumber"
                    inputProps={{
                      pattern: "\\+[1-9]{1}[0-9]{1,2}[0-9]{10}",
                    }}
                    margin="dense"
                    fullWidth={true}
                    onChange={handleSalesManagerChange}
                    onBlur={(e) => {
                      const value = e.target.value;

                      setErrors((prev) => ({
                        ...prev,
                        salesManagerPhoneNumber: isValidPhone(value)
                          ? ""
                          : "Enter valid phone Number.",
                      }));
                    }}
                    error={Boolean(errors.salesManagerPhoneNumber)}
                    helperText={errors.salesManagerPhoneNumber}
                    FormHelperTextProps={{
                      sx: {
                        color: "#d32f2f",
                        fontSize: "12px",
                        marginLeft: "4px",
                      },
                    }}
                  />
                </MDBox>
                <MDBox p={1}>
                  <MDInput
                    type="text"
                    label="Security Guard Name"
                    value={values.dealer.name}
                    name="dealer.name"
                    margin="dense"
                    fullWidth={true}
                    onChange={handleDealerChange}
                    onBlur={(e) => {
                      const value = e.target.value;
                      setErrors((prev) => ({
                        ...prev,
                        securityGuardName: allowOnlyAlphanumericAndSpace(value)
                          ? ""
                          : "Only letters are allowed.",
                      }));
                    }}
                    error={Boolean(errors.securityGuardName)}
                    helperText={errors.securityGuardName}
                    FormHelperTextProps={{
                      sx: {
                        color: "#d32f2f",
                        fontSize: "12px",
                        marginLeft: "4px",
                      },
                    }}
                  />
                </MDBox>

                <MDBox p={1}>
                  <MDInput
                    type="email"
                    label="Security Guard Email"
                    value={values.dealer.email}
                    name="dealer.email"
                    margin="dense"
                    pattern=".+@+.+.com"
                    fullWidth={true}
                    onChange={handleDealerChange}
                    onBlur={(e) => {
                      const value = e.target.value;

                      setErrors((prev) => ({
                        ...prev,
                        securityGuardEmail: isValidEmail(value)
                          ? ""
                          : "Enter valid email address.",
                      }));
                    }}
                    error={Boolean(errors.securityGuardEmail)}
                    helperText={errors.securityGuardEmail}
                    FormHelperTextProps={{
                      sx: {
                        color: "#d32f2f",
                        fontSize: "12px",
                        marginLeft: "4px",
                      },
                    }}
                  />
                </MDBox>
                <MDBox p={1}>
                  <MDInput
                    type="number"
                    label="Security Guard Phone"
                    value={values.dealer.phoneNumber}
                    name="dealer.phoneNumber"
                    inputProps={{
                      pattern: "\\+[1-9]{1}[0-9]{1,2}[0-9]{10}",
                    }}
                    margin="dense"
                    fullWidth={true}
                    onChange={handleDealerChange}
                    onBlur={(e) => {
                      const value = e.target.value;

                      setErrors((prev) => ({
                        ...prev,
                        securityGuardPhoneNumber: isValidPhone(value)
                          ? ""
                          : "Enter valid phone Number.",
                      }));
                    }}
                    error={Boolean(errors.securityGuardPhoneNumber)}
                    helperText={errors.securityGuardPhoneNumber}
                    FormHelperTextProps={{
                      sx: {
                        color: "#d32f2f",
                        fontSize: "12px",
                        marginLeft: "4px",
                      },
                    }}
                  />
                </MDBox>
                <MDBox p={1}>
                  <FormLabel>Location Image</FormLabel>
                </MDBox>

                <MDBox p={1}>
                  <Upload
                    customRequest={({ file, onSuccess }) =>
                      setTimeout(() => onSuccess("ok"), 0)
                    }
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleUploadChange}
                  >
                    {fileList.length >= 6 ? null : uploadButton}
                  </Upload>
                </MDBox>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-around"
                  p={2}
                >
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={reset}
                  >
                    Reset
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={handleSubmit}
                  >
                    Submit
                  </MDButton>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default UpdateLocation;
